import Repository from "../Repository";

export default {
  uploadFile: (payload) => {
    return Repository.post('/file', payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  uploadImage: (payload) => {
    return Repository.post('/file/image', payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  uploadVideo: (payload) => {
    return Repository.post('/file/video', payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
}
